import { Component, OnInit } from '@angular/core';
import { Cambio } from '../../models/Administrativo/Cambio';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from '../../Services/userservice.service'
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';

@Component({
    selector: 'app-request-password',
    templateUrl: './request-password.component.html',
    styleUrls: ['./request-password.component.scss']
})
export class RequestPasswordComponent implements OnInit {

    constructor(
        private route: Router,
        private userServices: UserService,
        private _snackBar: MatSnackBar,
        private location: Location
    ) { }
    public emailObject;

    onSubmit(userEditForm) {
        try {
            console.log(this.location['_locationStrategy']['_platformLocation']['_location']['hostname'] ) ;
           // console.log(this.location['_locationStrategy']['_platformLocation']['_location']) ;
            let hostname = this.location['_locationStrategy']['_platformLocation']['_location']['hostname'];
            console.log(this.emailObject)
            let mailVerify = this.emailObject.email;
            let mail;
            if (/^[a-zA-Z0-9.!#$%&'*/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi.test(mailVerify)) {
                mail = mailVerify
            } else {
                this._snackBar.open("Correo electrónico inválido", "Cerrar");
                return;
            }

            const objectForSend = {
                mail,
                hostname
            }

            this.userServices.verifyEmail(objectForSend).subscribe(
                res => {
                    console.log(res);
                    if (res.limit == 1) {
                        this.route.navigate(['login']);
                        this._snackBar.open("Enviamos un mensaje a su correo electrónico, ingrese a su bandeja y podrá seguir los pasos para cambiar contraseña", "Cerrar");
                    } else {
                        this._snackBar.open("Correo electrónico no existente", "Cerrar");
                    }
                },
                err => {
                    //console.log(err);
                    this._snackBar.open("Correo electrónico inválido", "Cerrar");
                }
            )
        } catch (err) {
            console.log(err)
        }
    }

    ngOnInit(): void {
        this.emailObject = new Cambio(1, '')
    }
}
